import { toHandlerKey } from 'vue'

export function toPanelEventProps(events: Record<string, any> = {}): Record<string, any> {
  return Object.fromEntries(
    Object.entries(events).map(([event, handler]) => [toHandlerKey(event), handler]),
  )
}
